import { TRowsSkeletonProps } from './types';

export const RowsSkeleton = ({ rows = 1, rowHeight = 40 }: TRowsSkeletonProps) => {
  return (
    <>
      <div className="flex flex-col w-full animate-pulse delay-100 gap-1 my-4">
        {Array.from({ length: rows }).map((_, idx) => (
          <div
            className={`w-full bg-gray-200 rounded`}
            key={idx}
            style={{ height: `${rowHeight}px` }}
          />
        ))}
      </div>
    </>
  );
};
